import { default as domainCourse } from './course/store'
import { default as domainCourseCluster } from './cluster/store'

export default {
    domainCourse,
    domainCourseCluster
}